/* eslint-disable */

import { WorkerActions } from "../../utils/enum";

const ctx: Worker = self as any;

let timeout;
let interval;

ctx.addEventListener('message', (event) => {
  const { data: { action, value } } = event;

  if (action === WorkerActions.counterStart) {
    timeout = setTimeout(() => {
      ctx.postMessage({ action: WorkerActions.counterEnd, value: 'Finished count' });
    }, value);
  }
  if (action === WorkerActions.counterReset) {
    clearTimeout(timeout);
  }
  if (action === WorkerActions.counterResetWithLogicStart) {
    timeout = setTimeout(() => {
      ctx.postMessage({ action: WorkerActions.counterResetWithLogicEnd, value: 'Finished count with logic' });
    }, value);
  }
  if (action === WorkerActions.timeoutComponentCountdown) {
    let secondsLeft = value;
    interval = setInterval(() => {
      secondsLeft--;
      ctx.postMessage({ action: WorkerActions.timeoutComponentIntervalValue, value: secondsLeft });
    }, 1000);
  }
  if (action === WorkerActions.timeoutComponentCountdownIntervalClear) {
    clearInterval(interval);
  }
});

export default {} as typeof Worker & { new(): Worker };